module.exports = __webpack_public_path__ + "static/blog03-72ed3ade962777559fac4badbadf4caf.png";